import { gql } from 'graphql-request'

export namespace TicketReasonsQueries {
  export const QUERY_KEY = 'getTicketReasons'

  export function getTicketReasons() {
    return gql`
      query TicketReasons($filter: TicketReasonFilter) {
        ticketReasons(filter: $filter) {
          id
          description
          ticketTypeId
          ticketType
        }
      }
    `
  }
}
